<template>
  <div :class="$style.wrapper">
    <p :class="$style.title">iichiのプライバシーポリシーが変更されました</p>
    <p :class="$style.lead">
      続けるには<a class="external" href="/privacy" target="_blank">プライバシーポリシー</a>を確認の上、同意が必要です。<br />
      プライバシーポリシー改定のお知らせは<a class="external" href="/news/ql1jaubbuby" target="_blank">こちら</a>。
    </p>
    <IButton type="primary" @click="onClickAgree">同意する</IButton>
    <p :class="$style.logout"><a href="/signout">同意しない（ログアウト）</a></p>
  </div>
</template>

<script setup lang="ts">
import { agree } from '@/js/lib/api/v1/account/your/account';
import { useUserStore } from '@/js/lib/store/user';
import { info, loading } from '@/js/lib/ui';
import { PERMISSION_ID_POLICY_UPDATE_202403 } from '@/js/data/permission';
import IButton from '@/js/components/molecules/IButton.vue';

const userStore = useUserStore();
const onClickAgree = () => {
  loading({
    asyncFunc: async () => {
      try {
        await agree({ settingId: PERMISSION_ID_POLICY_UPDATE_202403 });
        userStore.updatePermission([PERMISSION_ID_POLICY_UPDATE_202403]);
      } catch (error) {
        info(error, { fadeOut: false });
      }
    },
  });
};
</script>

<style module lang="scss">
.wrapper {
  text-align: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}

.lead {
  margin-bottom: 16px;

  @media (--sp) {
    text-align: left;
  }
}

.logout {
  margin-top: 16px;
}
</style>
